<script lang="ts">
	import Box from '$lib/components/box.svelte';
	import Header from '$lib/components/header.svelte';
	import PopBox from '$lib/components/popBox.svelte';
	import Tags from '$lib/components/tags.svelte';
	import { onMount } from 'svelte';

	let { data }: any = $props();
	let Content = $derived(data.thought.Content);

	onMount(() => {
		document.title = data.thought.meta.title;
		if (window.location.href.endsWith('.md')) {
			window.location.href = `/garden/${data.thought.meta.title}`;
		}
	});
</script>

<div class="outer-body" style="flex-direction: column; max-height: unset; max-width: 100dvw">
	<Header notes={data.headerNotes} />
	<Box
		style="margin: 1.5em auto; width: 35dvw; min-width: min(calc(100% - 6em), 40em); flex: 15 15 auto; padding: 1.5em;"
	>
		<PopBox style="padding: 0 1em; margin-bottom: 0.5em;">
			<h1 style="margin: 0">{data.thought.meta.title}</h1>
			<Tags note={data.thought.meta} />
		</PopBox>

		<div data-pagefind-body>
			{@html Content}
		</div>

		{#if data.thought.meta.modified}
			<PopBox style="padding: 0 1em; margin-top: 0.5em;">
				<h5 style="margin: 0.6em 0">
					Created
					{new Date(data.thought.meta.modified[0]).toLocaleDateString()}
				</h5>
				<h5 style="margin: 0.6em 0">
					Tended
					<ul style="margin-top: 0">
						{#each data.thought.meta.modified.reverse() as date}
							<li>{new Date(date).toLocaleDateString()}</li>
						{/each}
					</ul>
				</h5>
			</PopBox>
		{/if}
	</Box>
</div>
